import React, { Component } from "react";
import * as Constants from "../../common/Global/constants";
import {
  getLocalStorageVariables,
  getThemeSettingsVariables,
  isEmptyVariable,
  isEmptyArray,
  handleTokenExpiry,
  getClientResponseDeadlineBadge,
} from "../../common/Global/commonFunctions";
import { Modal } from "react-bootstrap";
import { DialogProceedButton } from "../../common/Global/globalStyles.style";
import TreeNodeDropdown from "../../common/DropdownMenus/TreeNodeDropdownObservations";
import AlertDialog from "../../common/AlertDialog";
import AlertWithTextareaDialog from "../../common/AlertDialog/alertwithTextarea";
import MasterMenuTabs from "./topmenu";
import ObservationDetailsLayout from "./observationDetails";
import AuditeeSidebar from "../../common/AuditeeSidebar";
import AuditeeTopbar from "../../common/AuditeeTopbar";
import ViewResponseCommentDialog from "./viewResponseCommentsdialog";
import AddNewResponseDialog from "./addNewResponseDialog";
// import ReAssignForResponseObservation from "./reAssignForResponseObservation";

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();

const resetLayoutFlags = {
  showObservationTree: false,
  showObservationDetails: false,
  showDonotReportObservations: false,
  showTaskList: false,
};
class HeadingTreeDialog extends Component {
  constructor(props) {
    super(props);
    const item = props.location.state;
    this.state = {
      showLoader: false,

      assignmentId: this.props.match.params.id,
      headingMap: {},
      assignmentObj: {},
      actionArr: [],
      allowEdit: "Y",
      syncFusionData: [],
      rootReportHeadingId: "",
      company: {},

      showCreateDialog: false,
      showCreateTextDialog: false,
      isEdit: false,
      createNodeType: "",
      selectedId: "",
      heading: "",
      relativeFunctionId: "",
      clearAndResetFunctionTree: true,
      idToBeExpandedAfterAddingChild: "",

      operationType: "",
      deleteReactivateId: "",
      showAlertWithRadioDialog: false,
      alertWithRadioDialogMessage: "",
      showBtnLoader:false,
      showAlertDialogInfo: false,
      alertDialogMessageInfo: "",
      showAlertDialog: false,
      showAlertTextareaDialog: false,
      alertDialogHeading: "",
      alertDialogMessage: "",
      proceedBtnLabel: "",

      showAddResponseDialog: false,
      showViewResponseDialog: false,

      showObservationTree: false,
      showObservationDetails: false,
      showDonotReportObservations: false,
      showTaskList: false,
      componentDidMountFlag:false,
      //download report
      companyDownloadReport: "",
      unitListId: item?.unitListId || [],
      executionTemplateId: item?.executionTemplateId || "",
      filterPlaceholder: "Tasks",

      showReassignEmployeeModal: false,
      reassignModalHeadingObj: null,
      reassignSelectedEmployee: null,
      reassignEmployeesList: [],
      reassignEmployeesLoaded: false,
      reassignSearchText: "",
      reassignSaving: false,
    };
    this.fields = {};
    userDetails = getLocalStorageVariables();
    themeSettings = getThemeSettingsVariables();
  }

  componentDidMount() {
    this.fields = {
      dataSource: [],
      id: "nodeId",
      text: "reportHeadingText",
      parentID: "parentId",
      child: "newChildren",
      expanded: "isExpanded",
    };

    this.getFunctionTree();
  }

  handleAddResponseDialogClose = (reloadFlag) => {
    this.setState({
      showAddResponseDialog: false,
      selectedId: "",
    },() => {
      if (reloadFlag === true) this.getFunctionTree();
    });
  };

  handleViewResponseDialogClose = (reloadFlag) => {
    this.setState({
      showViewResponseDialog: false,
      selectedId: "",
    },() => {
      if (reloadFlag === true) this.getFunctionTree();
    });
  };

  onDropDownItemClick = () => {
  
  };

  handleAddResponse = (headingObj) => {
    this.setState({
      showAddResponseDialog:true,
      selectedId:headingObj.nodeId,
      selectedClientResponseDeadline:headingObj.clientResponseDeadline,
    });
  }
  handleViewResponse = (headingObj) => {
    this.setState({
      showViewResponseDialog:true,
      selectedId:headingObj.nodeId,
      selectedClientResponseDeadline:headingObj.clientResponseDeadline,
    });
  }
  handleObservationDetails = (headingObj) => {
    this.setState({
      ...resetLayoutFlags,
      showObservationDetails:true,
      selectedId:headingObj.nodeId,
    })
  }

  handleAlertDialogCloseInfo = () => {
    this.setState({
      showAlertDialogInfo: false,
      alertDialogMessageInfo: "",
    });
  };

  getRootLevelFunctions = (functionMapTemp) => {
    let rootFunctionArr = [];
    Object.values(functionMapTemp).map((item) => {
      if (item.level === 0 || item.level === null) {
        rootFunctionArr.push(item);
      }
    });
    return rootFunctionArr;
  };

  //No need of return value since the array itself is passed and updated.
  //Javascript maintains single array with pointers. it will not deep copy the array
  addParentIdandHasChildrenFlag = (
    tempArr,
    nodeId,
    level,
    parentHeadingId,
    prefix
  ) => {
    tempArr[nodeId].level = level;
    tempArr[nodeId].parentHeadingId = parentHeadingId;
    if (prefix !== "0") {
      tempArr[nodeId].reportHeadingText =
        prefix + ".\xa0\xa0" + tempArr[nodeId].reportHeadingText;
    }

    // add parent Id to all the observations; exclude those with a submitted response
    let filteredObsList = tempArr[nodeId].observationList.filter(
      item => item.isResponseSubmitted !== true && item.isResponseSubmitted !== "Y"
    );
    let ObsList = filteredObsList.map((item, index) => {
      item.parentId = parentHeadingId;
      if (prefix === "0") {
        item.reportHeadingText =
          index + 1 + ".\xa0\xa0\xa0\xa0" + item.reportHeadingText;
      } else {
        item.reportHeadingText =
          prefix +
          "." +
          (index + 1) +
          ".\xa0\xa0\xa0\xa0" +
          item.reportHeadingText;
      }
      item.level = level + 1;
      return item;
    });
    tempArr[nodeId].observationList = ObsList;

    if (!isEmptyArray(tempArr[nodeId].children)) {
      tempArr[nodeId].children.map((childNode, index) => {
        let newPrefix = prefix === "0" ? index + 1 : prefix + "." + (index + 1);
        this.addParentIdandHasChildrenFlag(
          tempArr,
          childNode.nodeId,
          level + 1,
          nodeId,
          newPrefix
        );
      });
    } else {
      tempArr[nodeId].hasChildren = false;
    }
    tempArr[nodeId].reportHeadingText = tempArr[nodeId].reportHeadingText.split('$_$')[0];
  };

  createSyncHRFusionData = (parentId, nodeId, headingMap, isExpanded) => {
    //Now create an object
    let headingObj = headingMap[nodeId];
    if(headingObj){
      headingObj.newChildren = [...headingObj.observationList];
      headingObj.isExpanded = isExpanded;
      headingObj.fontbold = true;
      if (parentId !== nodeId) {
        headingObj.parentId = parentId;
      }
      //now add children recursively
      headingObj.children.map((item) => {
        headingObj.newChildren.push(
          this.createSyncHRFusionData(nodeId, item.nodeId, headingMap, true)
        );
      });
      return headingObj;
    }
  };

  updateSyncHRFusionData = (parentId, nodeId, headingMap) => {
    //Now create an object
    let headingObj = headingMap[nodeId];
    headingObj.newChildren = [...headingObj.observationList];
    headingObj.fontbold = true;
    //Check the old function map
    if (!isEmptyVariable(this.state.headingMap[nodeId])) {
      headingObj.isExpanded = this.state.headingMap[nodeId].isExpanded;
      headingMap[nodeId].isExpanded = this.state.headingMap[nodeId].isExpanded;
    }

    if (parentId !== nodeId) {
      headingObj.parentId = parentId;
    }
    //now add children recursively
    headingObj.children.map((item) => {
      headingObj.newChildren.push(
        this.updateSyncHRFusionData(nodeId, item.nodeId, headingMap)
      );
    });
    return headingObj;
  };

  hideObservationDetails = () => {
    this.setState({
      ...resetLayoutFlags,
      showObservationTree: true,
      selectedId: "",
    });
  };

  /************************API CALLS **************************/
  HeadingTree = (headingObj) => {
    let actions = [];
    if (headingObj.level === 1) {
      actions = this.state.actionArr;
    } else if (headingObj.type === "heading") {
      actions = this.state.actionArr;
    } else if (headingObj.observationType === "comment") {
      actions = this.state.actionArrFreeText;
    }
    const isAccepted = headingObj.acceptedStatus === "accepted";
    const isObservationNode = headingObj.level !== 1 && headingObj.type !== "heading" && headingObj.observationType !== "comment";
    return (
      <div
        className={
          headingObj.fontbold
            ? "dialog-tree-structure-sync"
            : "dialog-tree-structure-sync border-bottom p-0"
        }
      >
        {!isEmptyVariable(headingObj) && (
          <div className="tree-node-sync">
            {
              <div className="tree-dropdown-layout-sync">
                <TreeNodeDropdown
                  placeholder={headingObj.reportHeadingText}
                  dropdownArr={actions}
                  labelParam={"label"}
                  onDropDownItemClick={this.onDropDownItemClick}
                  dropdownId={headingObj}
                  fontbold={headingObj.fontbold}
                  paraMT={"1.5px"}
                  themeSettings={themeSettings}
                  onTitleClick={isObservationNode ? () => this.handleObservationDetails(headingObj) : undefined}
                />
                {isObservationNode &&
                  <>
                    {(() => {
                      const deadlineBadge = getClientResponseDeadlineBadge(headingObj.clientResponseDeadline);
                      return deadlineBadge && (
                        <div className="tool ml-2" data-title={deadlineBadge.tooltip}
                          style={{
                            display:"inline-block",
                            padding:"3px 10px",
                            borderRadius:12,
                            fontSize:11, fontWeight:600, whiteSpace:"nowrap",
                            background:deadlineBadge.bgColor, color:deadlineBadge.textColor
                          }}>
                          {deadlineBadge.text}
                        </div>
                      );
                    })()}
                    {isAccepted && (
                      <div className="tool ml-2 c-pointer" data-title="View Responses">
                        <span
                          className="material-icons"
                          style={{
                            color: headingObj.responseCount === 0 ? "#777777":
                            `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                            fontSize:18
                          }}
                          onClick={() => this.handleViewResponse(headingObj)}
                        >
                          chat
                        </span>
                      </div>
                    )}
                    {!isAccepted && (
                      <div className="tool ml-2 c-pointer" data-title="Accept">
                        <span
                          className="material-icons"
                          style={{
                            color: `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                            fontSize: 18,
                          }}
                          onClick={() => this.handleAcceptObservationClick(headingObj.observationId)}
                        >
                          check_circle
                        </span>
                      </div>
                    )}
                    <div className="tool ml-2 c-pointer" data-title="Reject">
                      <span
                        className="material-icons"
                        style={{
                          color: headingObj.clientStatus === "Rejected" ? "#e53935"
                            : `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                          fontSize: 18,
                        }}
                        onClick={() => this.handleRejectObservationClick(headingObj.observationId)}
                      >
                        cancel
                      </span>
                    </div>
                    {this.state.isAllowReassignTaskByClientEnabled && (
                      <div className="tool tool-right ml-2 c-pointer" data-title="Reassign to Employee">
                        <span
                          className="material-symbols-outlined"
                          style={{
                            color: `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                            fontSize: 18,
                          }}
                          onClick={() => this.handleReassignIconClick(headingObj)}
                        >
                          chat_paste_go
                        </span>
                      </div>
                    )}
                  </>
                }
              </div>
            }
          </div>
        )}
      </div>
    );
  };

  renderTree = (nodes) => {
    if (!nodes || nodes.length === 0) return null;
    return (
      <ul style={{ listStyle: 'none', paddingLeft: '20px' }}>
        {nodes.map((node, index) => (
          <li key={node.nodeId || index}>
            {this.HeadingTree(node)}
            {node.newChildren && node.newChildren.length > 0 && this.renderTree(node.newChildren)}
          </li>
        ))}
      </ul>
    );
  };

  displayObservationTree = (nodes, indent = '') => {
    if (!nodes || nodes.length === 0) return;
    nodes.forEach((node) => {
      if (node.newChildren && node.newChildren.length > 0) {
        this.displayObservationTree(node.newChildren, indent + '  ');
      }
    });
  };

  handleShowOverallAssignment = (event) => {
    event.preventDefault();
    window.location = Constants.URL_DRAFT_GENERAL + "/" + this.state.assignmentId;
  }

  handleAssignForResponse = () => {
    this.setState({
      showAssignForResponse:true,
    })
  }

  handleAssignForResponseDialogClose = () => {
    this.setState({
      showAssignForResponse:false
    })
  }

  // handleReAssignForResponse = () => {
  //   this.setState({
  //     showReAssignForResponse:true
  //   })
  // }

  // handleReAssignForResponseDialogClose = (reloadFlag) => {
  //   this.setState({
  //     showReAssignForResponse:false,
  //   },() => {
  //     if(reloadFlag === true){
  //       this.getFunctionTree();
  //     }
  //   })
  // }

  handleReassignIconClick = (headingObj) => {
    this.setState({
      showReassignEmployeeModal: true,
      reassignModalHeadingObj: headingObj,
      reassignSelectedEmployee: null,
      reassignSearchText: ""
    });
    if(!this.state.reassignEmployeesLoaded){
      this.fetchReassignEmployees();
    }
  }

  handleReassignModalClose = () => {
    this.setState({
      showReassignEmployeeModal: false,
      reassignModalHeadingObj: null,
      reassignSelectedEmployee: null
    });
  }

  handleReassignEmployeeClick = (employee) => {
    this.setState({ reassignSelectedEmployee: employee });
  }

  fetchReassignEmployees = () => {
    fetch(Constants.EmployeeOrAuditeeList,{
      method:"POST",
      mode:'cors',
      body: new URLSearchParams({
        email:userDetails.email,
        accessToken:userDetails.accessToken,
        assignmentId:this.state.assignmentId,
        userType:'ae'
      })
    })
    .then(response => response.json())
    .then(data => {
      if(handleTokenExpiry(data.responseCode)) return;
      if(data.responseCode === Constants.CODE_SUCCESS){
        const draftAssignmentAuditeeList = data.data.draftAssignmentAuditeeList || [];
        const clientEmployeeList = data.data.clientEmployeeList || [];

        const matchingAssignmentUnit = clientEmployeeList.filter(emp => {
          const unitId = JSON.parse(emp.unit)[0];
          return this.state.unitListId.includes(unitId);
        });
        const otherEmployees = clientEmployeeList.filter(emp => {
          const unitId = JSON.parse(emp.unit)[0];
          return !this.state.unitListId.includes(unitId);
        });

        const employees = [...draftAssignmentAuditeeList, ...matchingAssignmentUnit, ...otherEmployees];
        const employeesList = employees
          .map(emp => ({
            ...emp,
            fullName:`${emp.firstName} ${emp.lastName} (${emp.designation})`
          }))
          .filter(emp => emp.employeeEmail !== userDetails.email);

        this.setState({
          reassignEmployeesList: employeesList,
          reassignEmployeesLoaded: true
        });
      }
    });
  }

  handleReassignSearchChange = (e) => {
    this.setState({ reassignSearchText: e.target.value });
  }

  handleReassignSave = () => {
    const headingObj = this.state.reassignModalHeadingObj;
    const employee = this.state.reassignSelectedEmployee;
    if(isEmptyVariable(headingObj) || isEmptyVariable(employee)) return;

    this.setState({ reassignSaving: true });

    let aeList = JSON.stringify([{
      employeeId: employee.employeeId,
      employeeType: employee.employeeType,
      observationId: headingObj.observationId
    }]);

    fetch(Constants.ReAssign, {
      method:"POST",
      mode:'cors',
      body: new URLSearchParams({
        email:userDetails.email,
        accessToken:userDetails.accessToken,
        aeList:aeList,
        assignmentId:this.state.assignmentId,
        clientResponseDeadline: headingObj.clientResponseDeadline || ""
      })
    })
    .then(response => response.json())
    .then(data => {
      if(handleTokenExpiry(data.responseCode)) return;
      this.setState({ reassignSaving: false });
      if(data.responseCode === Constants.CODE_SUCCESS){
        this.handleReassignModalClose();
        this.getFunctionTree();
      }else{
        this.setState({
          showAlertDialogInfo:true,
          alertDialogMessageInfo:data.responseMessage
        })
      }
    });
  }

  handleAcceptObservationClick = (observationId) => {
    this.setState({
      showAlertDialog: true,
      operationType: "Accept",
      deleteReactivateId: observationId,
      alertDialogHeading: "Accept Observation",
      alertDialogMessage: "Are you sure you want to accept this observation?",
      proceedBtnLabel: "Accept",
    });
  }

  handleRejectObservationClick = (observationId) => {
    this.setState({
      showAlertTextareaDialog: true,
      operationType: "Reject",
      deleteReactivateId: observationId,
      alertDialogHeading: "Reject Observation",
      alertDialogMessage: "You are about to reject the observation and send observation back to auditor. Are you sure you want to reject the observation?",
      proceedBtnLabel: "Reject",
    });
  }

  handleAlertDialogClose = () => {
    this.setState({
      showAlertDialog: false,
      operationType: "",
      deleteReactivateId: "",
    });
  }

  handleAlertTextareaDialogClose = () => {
    this.setState({
      showAlertTextareaDialog: false,
      operationType: "",
      deleteReactivateId: "",
    });
  }

  handleObservationRecordOperation = (remarks) => {
    const { operationType, deleteReactivateId } = this.state;
    const acceptedStatus = operationType === "Accept" ? "accepted" : "rejected";

    this.setState({ showBtnLoader: true });

    const bodyParams = {
      email: userDetails.email,
      accessToken: userDetails.accessToken,
      observationId: deleteReactivateId,
      acceptedStatus: acceptedStatus,
    };

    if (operationType === "Reject" && remarks) {
      bodyParams.acceptedStatusRemarks = remarks;
    }

    fetch(Constants.AcceptedStatus, {
      method: "POST",
      mode: "cors",
      body: new URLSearchParams(bodyParams),
    })
    .then(res => res.json())
    .then(res => {
      if (handleTokenExpiry(res.responseCode)) return;
      if (res.responseCode === Constants.CODE_SUCCESS) {
        this.setState({ showAlertDialog: false, showAlertTextareaDialog: false, showBtnLoader: false }, () => {
          this.getFunctionTree();
        });
      } else {
        this.setState({
          showBtnLoader: false,
          showAlertDialog: false,
          showAlertTextareaDialog: false,
          showAlertDialogInfo: true,
          alertDialogMessageInfo: res.responseMessage,
        });
      }
    });
  }

  isAllowReassignTaskByClientEnabled(tempTemplateSettings) {
    return (
      tempTemplateSettings &&
      tempTemplateSettings?.allowReassignTaskByClient &&
      tempTemplateSettings?.allowReassignTaskByClient.settingColumnEnabled === "Y"
    );
  }

  /*******************API CALLS*******************/
  getFunctionTree = () => {
    this.setState({
      showLoader: true,
    });

    Promise.all([
      fetch(Constants.GetAuditeeEmployeeDraftReports+"/"+this.state.assignmentId+"/observations", {
        method: "POST",
        mode: "cors",
        body: new URLSearchParams({
          email: userDetails.email,
          accessToken: userDetails.accessToken
        }),
      }),
      fetch(Constants.GetTemplateSetting, {
        method: "POST",
        mode: 'cors',
        body: new URLSearchParams({
          email: userDetails.email,
          accessToken: userDetails.accessToken,
          templateId:this.state.executionTemplateId,
          userType:'ae'
        })
      })
    ])
    .then(([response,templateSettingsRes]) => {
      return Promise.all([
        response.json(), templateSettingsRes.json()
      ]);
    })
    .then(([data,templateSettingsRes]) => {
      if(handleTokenExpiry(data.responseCode)) return;
      else if (data.responseCode === Constants.CODE_SUCCESS) {
        let temp = data.data.finalHeadingMapping;
        let rootFunctionArr = this.getRootLevelFunctions(temp);
        let rootNodeId = "";
        rootFunctionArr.map((rootNode) => {
          rootNodeId = rootNode.nodeId;
          this.addParentIdandHasChildrenFlag(
            temp,
            rootNodeId,
            1,
            rootNodeId,
            "0"
          );
        });
        let syncFusionData = [];
        //clearAndResetFunctionTree - if it is false, then copy the isShowingChildren param
        //from old state array, this is required because whenever the user adds a new node at the nth level
        //all the nodes are collapsed and shows only first level nodes since the API is called again
        if (
          !isEmptyArray(Object.keys(this.state.headingMap)) &&
          !this.state.clearAndResetFunctionTree
        ) {
          rootFunctionArr.map((rootNode) => {
            let headingObj = this.updateSyncHRFusionData(
              rootNode.nodeId,
              rootNode.nodeId,
              temp
            );
            headingObj.fontbold = true;
            syncFusionData.push(headingObj);
          });
        } else {
          //create datastructure and Expand root level node's children by default
          rootFunctionArr.map((rootNode) => {
            let headingObj = this.createSyncHRFusionData(
              rootNode.nodeId,
              rootNode.nodeId,
              temp,
              true
            );
            if(!isEmptyArray(Object.keys(temp))){
              if (temp[rootNode.nodeId]) {
                temp[rootNode.nodeId].isExpanded = true;
              }
              headingObj.fontbold = true;
              syncFusionData.push(headingObj);
            }
          });
        }
        //set the tree fields
        this.fields = {
          dataSource: syncFusionData,
          id: "nodeId",
          text: "reportHeadingText",
          parentID: "parentId",
          child: "newChildren",
          expanded: "isExpanded",
        };       
        this.setState({
          headingMap: temp,
          idToBeExpandedAfterAddingChild: "",
          syncFusionData: syncFusionData,
          rootNodeId: rootNodeId,
          showLoader: false,
          clearAndResetFunctionTree: false,
          componentDidMountFlag:true
        });
        this.displayObservationTree(syncFusionData);
      } else {
        this.setState({
          headingMap: {},
          showLoader: false,
          syncFusionData: [],
          clearAndResetFunctionTree: false,
        });
      }

      let tempTemplateSettings = {};
      let isAllowReassignTaskByClientEnabled = false;
      if(handleTokenExpiry(templateSettingsRes.responseCode)) return;
      else if (templateSettingsRes.responseCode === Constants.CODE_SUCCESS) {
          tempTemplateSettings = templateSettingsRes.data[0]?.settingDetails ?? {};
          isAllowReassignTaskByClientEnabled = this.isAllowReassignTaskByClientEnabled(tempTemplateSettings);
      }else {
          tempTemplateSettings = ""
      }

      this.setState({
        isAllowReassignTaskByClientEnabled:isAllowReassignTaskByClientEnabled
      })
    });
  };
  /*******************API CALLS END HERE*******************/

  render() {
    return (
      <main className="main-dashboard">
        <section className="dashboard-bg">
          <AuditeeSidebar />

          <div className="dashboard-right-bg position-relative">
            <div className="dashboard-wrapper">
              <AuditeeTopbar />
              <div className="d-flex align-items-center">
                <div className="flex-fill">
                  <MasterMenuTabs
                    assignmentId={this.state.assignmentId}
                    themeSettings={themeSettings}
                    showTaskObservationTab={true}
                    executionTemplateId={this.state.executionTemplateId}
                    unitListId={this.state.unitListId}
                  />
                </div>
              </div>
              {this.state.showLoader && (
                <div class="loader"></div>
              )}
              {/* {this.state.isAllowReassignTaskByClientEnabled &&
                <div className="search-addnew-bg">
                  <div className="search-addnew">
                    <div className="search-filter-layout"></div>
                      <div className="flex-center-layout">
                          <div className="bordered-anchor" style={{ textAlign: "right" }}>
                            <a onClick={this.handleReAssignForResponse} href="javascript:void(0)">
                              <span className="material-icons"></span>
                              <p>Re-Assign For Response</p>
                            </a>
                          </div>
                      </div>
                  </div>
                </div>
              } */}
              {this.state.componentDidMountFlag &&
              !this.state.showObservationDetails &&
              !this.state.showReAssignForResponse && (
                <div className="row custom-row">
                  <div className="col-md-12 custom-col">
                    <div
                      style={{ padding: "0px 20px 20px" }}
                      className="card-col tree-node-bottom-border"
                    >
                      {this.renderTree(this.state.syncFusionData)}
                    </div>
                  </div>
                </div>
              )}
              {this.state.componentDidMountFlag &&
              !this.state.showObservationDetails &&
              !this.state.showReAssignForResponse &&
              isEmptyArray(this.state.syncFusionData) && (
                <div className="no-items-layout">
                  <div className="no-items-card">
                    <h6>{Constants.NO_RECORDS_WARNING}</h6>
                  </div>
                </div>
              )}
              {this.state.showObservationDetails && (
                <ObservationDetailsLayout
                  observationId={this.state.selectedId}
                  assignmentId={this.state.assignmentId}
                  handleHideObsDetailsLayout={this.hideObservationDetails}
                  allowEdit={false}
                  editUrl={
                      Constants.URL_EDIT_DRAFT_OBSERVATIONS +
                      "/" +
                      this.state.selectedId +
                      "-" +
                      this.state.assignmentObj?.assignmentId
                  }
                  isDraftOnward={true}
                />
              )}
              {/* {
                this.state.showReAssignForResponse &&
                <ReAssignForResponseObservation
                  handleReAssignForResponseDialogClose={this.handleReAssignForResponseDialogClose}
                  // datalist={this.fields}
                  assignmentId={this.state.assignmentId}
                  unitListId={this.state.unitListId}
                />
              } */}
            </div>
          </div>
        </section>

        <AlertDialog
          showAlertDialog={this.state.showAlertDialog}
          handleAlertDialogClose={this.handleAlertDialogClose}
          type={Constants.ALERT_TYPE_INFO}
          alertDialogHeading={this.state.alertDialogHeading}
          alertDialogMessage={this.state.alertDialogMessage}
          proceedBtnClick={this.handleObservationRecordOperation}
          proceedBtnLabel={this.state.proceedBtnLabel}
          showLoader={this.state.showBtnLoader}
          themeSettings={themeSettings}
        />

        <AlertWithTextareaDialog
          showAlertDialog={this.state.showAlertTextareaDialog}
          handleAlertDialogClose={this.handleAlertTextareaDialogClose}
          alertDialogHeading={this.state.alertDialogHeading}
          alertDialogMessage={this.state.alertDialogMessage}
          proceedBtnClick={this.handleObservationRecordOperation}
          proceedBtnLabel={this.state.proceedBtnLabel}
          showLoader={this.state.showBtnLoader}
          themeSettings={themeSettings}
        />

        <AlertDialog
          showAlertDialog={this.state.showAlertDialogInfo}
          handleAlertDialogClose={this.handleAlertDialogCloseInfo}
          type={Constants.ALERT_TYPE_ALERT}
          alertDialogMessage={this.state.alertDialogMessageInfo}
          proceedBtnClick={this.handleAlertDialogCloseInfo}
          proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
          themeSettings={themeSettings}
        />

        <AddNewResponseDialog
          showAddResponseDialog={this.state.showAddResponseDialog}
          handleAddResponseDialogClose={this.handleAddResponseDialogClose}
          observationId={this.state.selectedId}
          themeSettings={themeSettings}
          assignmentId={this.state.assignmentId}
        />

        <ViewResponseCommentDialog
          showViewResponseDialog={this.state.showViewResponseDialog}
          handleViewResponseDialogClose={this.handleViewResponseDialogClose}
          observationId={this.state.selectedId}
          assignmentId={this.state.assignmentId}
          themeSettings={themeSettings}
          location={this.props.location}
          allowEdit={this.state.allowEdit}
        />

        <Modal className="custom-dialog" show={this.state.showReassignEmployeeModal} backdrop="static">
          <Modal.Header>
            <h5>{"Reassign to Employee"}</h5>
            <button
              onClick={this.handleReassignModalClose}
              type="button" data-dismiss="modal">
              <span class="material-icons">close</span>
            </button>
          </Modal.Header>
          <div class="modal-body">
            <div className="addnew-modal-form">
              {this.state.reassignSelectedEmployee &&
                <div class="addnew-modal-form-group">
                  <div style={{
                    padding:"8px 12px", borderRadius:6, fontWeight:600, fontSize:13,
                    background:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},0.1)`,
                    color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`
                  }}>
                    {this.state.reassignSelectedEmployee.fullName}
                  </div>
                </div>
              }
              <div class="addnew-modal-form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search employee..."
                  value={this.state.reassignSearchText}
                  onChange={this.handleReassignSearchChange}
                />
              </div>
              <div class="addnew-modal-form-group" style={{maxHeight:220, overflowY:"auto"}}>
                {
                  isEmptyArray(this.state.reassignEmployeesList) ? (
                    <div style={{padding:"6px 8px", fontSize:13, color:"#777"}}>
                      {this.state.reassignEmployeesLoaded ? "No employees found" : "Loading..."}
                    </div>
                  ) : (
                    this.state.reassignEmployeesList
                      .filter(emp => emp.fullName.toLowerCase().includes(this.state.reassignSearchText.toLowerCase()))
                      .map((emp, empIdx) => {
                        const isSelected = this.state.reassignSelectedEmployee?.employeeId === emp.employeeId
                          && this.state.reassignSelectedEmployee?.employeeType === emp.employeeType;
                        return (
                          <div key={empIdx}
                            style={{
                              padding:"8px 10px", cursor:"pointer", fontSize:13, borderRadius:4,
                              background: isSelected ? "#f0f0f0" : "transparent"
                            }}
                            onClick={() => this.handleReassignEmployeeClick(emp)}
                          >
                            {emp.fullName}
                          </div>
                        );
                      })
                  )
                }
              </div>
            </div>
            <div class="dialog-btn-layout">
              <a class="alert-cancel" href="javascript:void(0);"
                onClick={this.handleReassignModalClose}
              >Cancel</a>
              <DialogProceedButton
                themeSettings={themeSettings}
                class="alert-proceed"
                href="javascript:void(0);"
                onClick={this.handleReassignSave}
                style={{
                  marginLeft:"10px",
                  opacity: isEmptyVariable(this.state.reassignSelectedEmployee) ? 0.5 : 1,
                  pointerEvents: isEmptyVariable(this.state.reassignSelectedEmployee) ? "none" : "auto"
                }}
              >
                {this.state.reassignSaving ? <div class="loader-btn mt-2"></div> : "Save"}
              </DialogProceedButton>
            </div>
          </div>
        </Modal>
      </main>
    );
  }
}

export default HeadingTreeDialog;
